<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="所属部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-select-depart v-decorator="['sysOrgCode', validatorRules.sysOrgCode]" customReturnField="orgCode"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="针对业务" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['projectBranch', validatorRules.projectBranch]" placeholder="请输入针对业务"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="公章名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['officialSealName', validatorRules.officialSealName]" :trigger-change="true" dictCode="name_of_official_seal" placeholder="请选择公章名称"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="协议种类" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag :disabled="isEdit" type="list" v-decorator="['protocolType', validatorRules.protocolType]" :trigger-change="true" dictCode="agreement_type" placeholder="请选择协议种类"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="对方公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-decorator="['oppositeCompanyName', validatorRules.oppositeCompanyName]"
                :trigger-change="true"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="文本提供方" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['agreementProvider', validatorRules.agreementProvider]" placeholder="请选择协议提供方"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="协议类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['forBusiness', validatorRules.forBusiness]" :trigger-change="true" dictCode="protocol_type" placeholder="请选择协议类型"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="险种" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['typeOfInsurance', validatorRules.typeOfInsurance]" placeholder="请输入险种"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="佣金比例" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['commissionRate', validatorRules.commissionRate]" placeholder="请输入佣金比例" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="协议名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['agreementName', validatorRules.agreementName]" placeholder="请输入协议名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="一式份数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['numberOfCopies', validatorRules.numberOfCopies]" placeholder="请输入一式份数" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="自留份数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['selfRetentionNumber', validatorRules.selfRetentionNumber]" placeholder="请输入自留份数" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="协议起期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择协议起期" v-decorator="['startDateOfAgreement', validatorRules.startDateOfAgreement]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label=" 协议止期" :labelCol="labelCol" :wrapperCol="wrapperCol">  <!--validatorRules.endDateOfAgreement-->
              <j-date class="end-date-of-agreement" placeholder="请选择协议止期" v-decorator="['endDateOfAgreement', {}]" :trigger-change="true" @change="handleEndDateChange" style="width: 80%; margin-right:30px;"/>
              <a-checkbox @change="handleEndLessChange" :checked="isEndLess">长期</a-checkbox>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="申请日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择申请日期" :disabled="isEdit" v-decorator="['dateOfApplication', validatorRules.dateOfApplication]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="申请人" :labelCol="labelCol" :wrapperCol="wrapperCol">
<!--              <a-input v-decorator="['applicant', validatorRules.applicant]" placeholder="请输入申请人"></a-input>-->
              <j-select-user-by-dep v-decorator="['applicant']"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保险公司联系人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insuranceCompanyContact', validatorRules.insuranceCompanyContact]" placeholder="请输入保险公司联系人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="联系人电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['contactNumber', validatorRules.contactNumber]" placeholder="请输入联系人电话"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="协议性质" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['protocolShape', validatorRules.protocolShape]" :trigger-change="true" dictCode="agreement_shape" placeholder="请选择协议种类"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="下级机构通用" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                                 type="list"
                                 v-decorator="['compatible']"
                                 :trigger-change="true"
                                 dictCode="yn"
                                 placeholder="是否下级机构通用"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-editor v-decorator="['remarks',{trigger:'input'}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="协议附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-upload v-decorator="['agreementPicture']" :trigger-change="true"  bizPath="agreement" :disabled="formDisabled" @change="handleFileChange"></j-upload>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction, postAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  
  import JUpload from '@/components/jeecg/JUpload'
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import JEditor from '@/components/jeecg/JEditor'
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'

  export default {
    name: 'BizAgreementinfoForm',
    components: {
      JFormContainer,
      JDate,
      JUpload,
      JSelectDepart,
      JSearchSelectTag,
      JDictSelectTag,
      JEditor,
      JSelectUserByDep,
    },
    props: {
      //表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        isEdit: false,
        startDisabled: false,
        endDisabled: false,
        isEndLess: false, //协议是否长期 默认否
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          sysOrgCode: {
            rules: [
              { required: true, message: '请选择所属部门!'},
            ]
          },
          projectBranch: {
            rules: [
              { required: true, message: '请输入针对业务!'},
              { max: 50, message: '业务长度不能超过50个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          officialSealName: {
            rules: [
              { required: true, message: '请选择公章名称!'},
            ]
          },
          protocolType: {
            rules: [
              { required: true, message: '请选择协议种类!'},
            ]
          },
          oppositeCompanyName: {
            rules: [
              { required: true, message: '请选择保险公司!'},
            ]
          },
          agreementProvider: {
            rules: [
              { required: true, message: '请输入文本提供方!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          forBusiness: {
            rules: [
              { required: true, message: '请选择协议类型!'},
            ]
          },
          typeOfInsurance: {
            rules: [
              { required: true, message: '请输入险种名称!'},
              { max: 50, message: '险种名称长度不能超过50个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          commissionRate: {
            rules: [
              { required: true, message: '请输入佣金比例!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          agreementName: {
            rules: [
              { required: true, message: '请输入协议名称!'},
              { max: 50, message: '协议名称不能超过50个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          numberOfCopies:{
            rules: [
              {type: 'integer', message: '只能输入整数'}
            ]
          },
          selfRetentionNumber:{
            rules: [
              {type: 'integer', message: '只能输入整数'}
            ]
          },
          startDateOfAgreement: {
            rules: [
              { required: true, message: '请输入协议起期!'},
            ]
          },
          // endDateOfAgreement: {
          //   rules: [
          //     { required: true, message: '请输入协议止期!'},
          //   ]
          // },
          dateOfApplication: {
            rules: [
              { required: true, message: '请输入申请日期!'},
            ]
          },
          applicant: {
            rules: [
              { required: true, message: '请输入申请人!'},
              { max: 30, message: '申请人长度不能超过30个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          insuranceCompanyContact: {
            rules: [
              { required: true, message: '请输入保险公司联系人!'},
              { max: 30, message: '公司联系人长度不能超过30个字符!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          contactNumber: {
            rules: [
              { required: true, message: '请输入联系人电话!'},
              { max: 13, message: '联系人电话格式不正确!'},
              { whitespace: true, message:'不能为空格'}
            ]
          },
          protocolShape: {
            rules: [
              { required: true, message: '请选择协议性质!'},
            ]
          },
        },
        url: {
          add: "/biz/bizAgreementinfo/add",
          edit: "/biz/bizAgreementinfo/edit",
          queryById: "/biz/bizAgreementinfo/queryById",
          updateFilePathImmediate: "/biz/bizAgreementinfo/updateFilePathImmediate",
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      showFlowSubmitButton(){
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        //编辑页面禁止修改协议起始时间
        if(this.model.id){
          this.isEdit = true;
          if(this.model.endDateOfAgreement == '长期'){ // 此日期约定为长期
            this.isEndLess = true;
            this.model.endDateOfAgreement = null; // 置空值
          } else {
            this.isEndLess = false;
          }
        }else{ // 新增
          this.isEdit = false;
          this.model.status = '0'; // 初始为未提交状态
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'sysOrgCode','protocolCode','projectBranch','officialSealName',
            'protocolType','oppositeCompanyName','agreementProvider','forBusiness','typeOfInsurance','commissionRate',
            'agreementName','numberOfCopies','selfRetentionNumber','startDateOfAgreement','endDateOfAgreement',
            'dateOfApplication','applicant','insuranceCompanyContact','contactNumber','remarks','agreementPicture',
            'status','protocolShape','compatible'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;

        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);

            formData.startDateOfAgreement = formData.startDateOfAgreement + " 00:00:00";
            this.trimFormData(formData);
            // 判断协议止期
            if(!that.isEndLess) {
              if (formData.endDateOfAgreement == null || formData.endDateOfAgreement.trim() == '') {
                that.$message.warn("必须设置协议止期");
                that.confirmLoading = false;
                return;
              }
              // 协议止期设置为当天的最大时间,不存在才添加
              if(formData.endDateOfAgreement.indexOf('23:59:59') <0){
                formData.endDateOfAgreement = formData.endDateOfAgreement +' 23:59:59'
              }
            }else if(that.isEndLess){
              formData.endDateOfAgreement = '2099-12-31 23:59:59'
            }

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      trimFormData(formData){
        formData.projectBranch = formData.projectBranch ? formData.projectBranch.trim() : '';
        formData.agreementProvider = formData.agreementProvider ? formData.agreementProvider.trim() : '';
        formData.typeOfInsurance = formData.typeOfInsurance ? formData.typeOfInsurance.trim() : '';
        formData.commissionRate = formData.commissionRate ? formData.commissionRate.trim() : '';
        formData.agreementName = formData.agreementName ? formData.agreementName.trim() : '';
        formData.applicant = formData.applicant ? formData.applicant.trim() : '';
        formData.insuranceCompanyContact = formData.insuranceCompanyContact ? formData.insuranceCompanyContact.trim() : '';
        formData.contactNumber = formData.contactNumber ? formData.contactNumber.trim() : '';
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'sysOrgCode','protocolCode','projectBranch','officialSealName','protocolType',
          'oppositeCompanyName','agreementProvider','forBusiness','typeOfInsurance','commissionRate','agreementName',
          'numberOfCopies','selfRetentionNumber','startDateOfAgreement','endDateOfAgreement','dateOfApplication',
          'applicant','insuranceCompanyContact','contactNumber','remarks','agreementPicture','status','compatible'))
      },

      handleEndDateChange(value){
        if(value != null && value.trim() != ''){
          this.isEndLess = false
          //this.form.setFieldsValue({isEndLess: false})
        }
      },

      handleEndLessChange(event){
        if(event && event.target.checked){
          this.isEndLess = true;
          //this.form.setFieldsValue({isEndLess: true})
          this.model.endDateOfAgreement = null;
          this.form.setFieldsValue({endDateOfAgreement: null})
        }
      },

      // 文件列表改变后及时更新数据库（编辑状态下）
      handleFileChange(filePath){
        // 编辑状态下变化，存在单据id
        let id = this.model.id
        if(id){
          postAction(this.url.updateFilePathImmediate, {id: id, filePath: filePath}).then(res =>{
            if(res.success){
            } else {
              this.$message.warn("附件更新时出现错误:" + res.message)
            }
          })
        }
      },
      getFormFieldValue(field){
        return this.form.getFieldValue(field)
      },
    }
  }
</script>

<style >
  /* 添加必选项标识 加空格防止污染其他地方*/
  [title=" 协议止期"]::before {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
  }

</style>